/**
 * Index/list routes: grant access if the user has any of these permissions
 * (backend often assigns `*-view` or `*-edit` without a separate `*-list`).
 * Keys must match `path.jsx` list paths and `sidebarConfig` item paths.
 */
export const LIST_ROUTE_ANY_PERMISSIONS = {
  '/invoices': ['invoice-list', 'invoice-view', 'invoice-edit'],
  '/payments': ['payment-list', 'payment-view'],
  '/payment-errors': ['payment-error-list', 'payment-error-view'],
  '/tasks': ['task-list', 'task-view', 'task-edit'],
  '/services': ['service-list', 'service-view', 'service-edit'],
  '/leases': [
    'lease-list',
    'lease-create',
    'lease-view',
    'lease-edit',
    'lease-delete',
    'lease-permanent-delete',
    'lease-restore',
    'lease-export',
  ],
  '/merchant-service-providers': [
    'merchant-service-provider-list',
    'merchant-service-provider-create',
    'merchant-service-provider-view',
    'merchant-service-provider-edit',
    'merchant-service-provider-delete',
    'merchant-service-provider-permanent-delete',
    'merchant-service-provider-restore',
    'merchant-service-provider-export',
  ],
  '/equipment-models': [
    'equipment-model-list',
    'equipment-model-create',
    'equipment-model-view',
    'equipment-model-edit',
    'equipment-model-delete',
    'equipment-model-bulk-delete',
    'equipment-model-permanent-delete',
    'equipment-model-restore',
  ],
  '/companies': ['company-list', 'company-view', 'company-edit'],
  '/task-types': ['task-type-list', 'task-type-view', 'task-type-edit'],
  '/task-categories': ['task-category-list', 'task-category-view', 'task-category-edit'],
  '/task-templates': ['task-template-list', 'task-template-view', 'task-template-edit'],
  '/lead-quizzes': ['lead-quiz-list', 'lead-quiz-view', 'lead-quiz-edit'],
  '/data': [
    'import-business-list-all',
    'import-business-list',
    'import-business-view',
    'import-business-edit',
    'import-business-create',
    'import-business-delete',
    'import-business-restore',
    'import-business-permanent-delete',
    'import-business-status',
    'import-business-assign',
  ],
  '/roles': ['role-list', 'role-view', 'role-edit', 'role-create'],
  '/statuses': ['status-list', 'status-view', 'status-edit', 'status-create'],
  '/customers': [
    'customer-list',
    'customer-create',
    'customer-view',
    'customer-edit',
    'customer-delete',
  ],
};
